module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d06-96c9dbe9ed3537ca0a2b6d408bff6636.jpg";